<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15mlcio/tc-custom/9781488044304.jpg?1708779380708" alt="This image is the cover for the book Crown Prince's Bought Bride, Conveniently Wed!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crown Prince's Bought Bride, Conveniently Wed!
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman goes from waitress to crown princess when she agrees to a royal wedding in this sexy international romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>Before taking the throne, Crown Prince Remirez Montegova has to do two things: find a wife, and resolve the royal scandal unintentionally triggered by stunning waitress Maddie Myers. Remi solves both problems by striking a deal with Maddie that she become his queen! But his innocent new bride awakens a passion he’d thought long buried. And after their scorching wedding night, suddenly their arrangement feels anything but convenient . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maya Blake
      </h2>
      
      <p class="authorDescription body article">Maya Blake's writing dream started at 13. She eventually realised her dream when she received The Call in 2012. Maya lives in England with her husband, kids and an endless supply of books. Contact Maya: www.mayabauthor.blogspot.com <a href="http://www.twitter.com/mayablake">www.twitter.com/mayablake</a>&#160;<a href="http://www.facebook.com/maya.blake.94">www.facebook.com/maya.blake.94</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ccb7f32